<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix m-b-5">
      <h3 class="pull-left m-v-0">
        <span v-if="school&&school.name">{{school.name}} -</span>
        <span v-if="is_edit">编辑用户</span>
        <span v-else>创建用户</span>
      </h3>
    </div>
    <el-form :model="form" class="form" :rules="rules" ref="form" label-width="6em" label-position="left">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="form.gender">
          <el-radio :label="gender" v-for="gender in genders" :key="gender"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="角色" prop="roles">
        <el-checkbox-group v-model="form.roles">
          <el-checkbox v-for="role in roles" :label="role.en_name" :key="role.en_name">{{role.name}}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="工号">
        <el-input v-model="form.number" placeholder="请输入工号"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="id_number">
        <el-input v-model="form.id_number" placeholder="请输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="所属部门" prop="departments">
        <el-select multiple v-model="form.departments" class="full-width">
          <el-option v-for="department in departments" :label="department.name"
                     :value="department.uid" :key="department.uid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任教学段" prop="grade">
        <el-radio-group v-model="form.grade" @change="form.subjects=[]">
          <el-radio :label="grade" v-for="grade in grades" :key="grade"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="所教科目" prop="subject">
        <el-checkbox-group v-if="form.grade" v-model="form.subjects">
          <span v-for="(subject, index) in subject_group_by_grade[form.grade]" :key="index">
            <el-checkbox :label="subject"></el-checkbox>
            <br v-if="index%3 === 2">
          </span>
        </el-checkbox-group>
        <div v-else>请选择学段</div>
      </el-form-item>
      <el-form-item label="任教班级" prop="groups">
        <el-select multiple filterable :filter-method="filterGroup" v-model="form.groups" class="full-width">
          <el-option v-for="group in filtered_groups" :label="group.name" :value="group.uid" :key="group.uid">
            <span v-html="$highlight(group.name, group.$$pinyin.name)"></span>
          </el-option>
        </el-select>
      </el-form-item>
      <div class="text-center m-v-10">
        <el-button type="primary" size="cons" @click="submit()" :loading="submit_loading>0">提交</el-button>
        <el-button type="default" size="cons" @click="$router.back()">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import * as Teacher from 'api/teacher'
import * as School from 'api/school'
import * as Group from 'api/group'
import * as Department from 'api/department'
import * as Subjects from 'api/configuration/subject'
import * as rules from 'common/rules'

import genders from 'constants/genders'

export default {
  data () {
    return {
      ready: false,
      form: null,
      school: null,
      roles: [],
      search: '',
      groups: [],
      departments: [],
      grades: [],
      subject_group_by_grade: {},
      submit_loading: 0,
      genders: genders(),
      rules: {
        name: [rules.required('用户姓名为必填项')],
        gender: [rules.required('用户性别为必填项')],
        roles: [rules.required({message: '用户角色为必填项', type: 'array'})],
        phone: [rules.phone()],
        email: [rules.email()],
        id_number: [rules.id_number()],
      },
    }
  },
  computed: {
    is_edit () {
      return !!this.$query.user_uid
    },
    filtered_groups () {
      return this.$search(this.groups, this.search, ['name'])
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let query = this.$query
        let [form, school, roles, groups, departments, subjects] = await Promise.all([
          query.user_uid ? Teacher.get(query) : null,
          query.school_uid ? School.get(query) : null,
          Teacher.roles(),
          Group.list(query),
          Department.list(query),
          Subjects.list(),
        ])
        form = form || {
          name: '',
          gender: '',
          roles: [],
          number: '',
          phone: '',
          email: '',
          id_number: '',
          departments: [],
          grade: '',
          subjects: [],
          groups: [],
        }
        form.uid = form.user_uid = query.user_uid
        form.school_uid = query.school_uid
        this.roles = roles
        this.form = form
        this.groups = groups
        this.subjects = subjects
        this.grades = Subjects.getGrades(subjects)
        this.subject_group_by_grade = Subjects.groupByGrade(subjects)
        this.school = school
        this.departments = departments
        this.ready = true
      })
    },
    async submit () {
      if (!await this.$validate(this.$refs.form)) return
      this.$guard(this, 'submit_loading')(async () => {
        await Teacher.edit(this.form)
        this.$message.success(this.is_edit ? '更新成功' : '创建成功')
        if (!this.is_edit) this.$router.back()
      })
    },
    filterGroup (search) {
      this.search = search
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
.form {
  max-width: 800px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account/teacher/TeacherEdit.vue